import React, { useEffect,useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link ,useParams} from 'react-router-dom';
import { toast } from 'react-toastify';
import {useNavigate} from 'react-router-dom';

const EditContact = () => {
    const [name,setName]=useState("");
    const [email,setEmail]=useState("");
    const [number,setNumber]=useState("");
    const {id}=useParams();
    const contacts=useSelector(state=>state);
    const dispatch=useDispatch();
    const history=useNavigate();
    const currentContact=contacts.find(contact=>contact.id===parseInt(id));

    useEffect(()=>{
        if(currentContact){
setName(currentContact.name);
setEmail(currentContact.email);
setNumber(currentContact.number);
        }
    },[currentContact])
    const handleSubmit=(e)=>{
        e.preventDefault();
    const checkEmail=contacts.find(contact=>contact.id!==parseInt(id) && contact.email===email)
    
    const checkNumber=contacts.find(contact=>contact.id!==parseInt(id) &&contact.number===parseInt(number))
    
        if(!email||!number||!name){
            return toast.warning("Please fill the values");
        }
        if(checkEmail){
            return toast.error("This email is already present in the database")
        }
        if(checkNumber){
            return toast.error("This number is already present in the database")
    
        }
        const data={
            id:parseInt(id),
            name,
            email,
            number
        }
        dispatch({type:"UPDATE_CONTACT",payload:data});
        toast.success("Record updated successfully");
        history("/");
    
    }

  return (
    <div className='container'>
        {currentContact?(
            <>
           <h1 className='display-3 my-5 text-center'>
        Edit Contact {id}
</h1>
    <div className='row'>
 


        <div className='col-md-6 shadow mx-auto p-5'>
            <br></br>
<form onSubmit={handleSubmit}>
    <div className='form-group'>
        <input type="text" placeholder='Name' className='form-control' value={name} onChange={e=>setName(e.target.value)}/>
        </div>
        <br></br>
        <div className='form-group'>
        <input type="email" placeholder='Email' className='form-control' value={email} onChange={e=>setEmail(e.target.value)}/>
        </div>
        <br></br>
        <div className='form-group'>
        <input type="number" placeholder='Phone Number' className='form-control' value={number} onChange={e=>setNumber(e.target.value)}/>
        </div>
        <br></br>
        <div className='form-group'>
        <input type="submit" value="Update Phone Number" className='btn btn-block btn-dark'/>
    </div>
    <br></br>
        <Link to="/" className='btn btn-block btn-danger'>Cancel</Link>


</form>
        </div>
    </div>
    </>
        ):(
            <h1 className='diplay-3 my-5 text-center'>Contact with id {id} doesnot exists</h1>
        )}
</div>
)
};

export default EditContact;
